







import { Component, Prop, Vue } from 'vue-property-decorator'
import AuthService from '../services/AuthService'
import router from './../router'

@Component
export default class Dashboard extends Vue {
  @Prop() private auth!: AuthService

  public created () {
    if (!this.auth.isAuthenticated()) {
      router.replace('/')
    }
  }
}
